import React from "react";
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Polyline
} from "react-google-maps";
import {
    compose,
    withProps,
    withStateHandlers,
    lifecycle
} from "recompose";
import Spinner from "views/lib/components/Spinner";
import MapMarker from "views/pages/bikes/map-marker";

const googleMapURL = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization";
const MapComponent = compose(
    withProps({
        googleMapURL,
        loadingElement: <Spinner />,
        containerElement: <div style={{
            // height: "calc(100vh - 140px)",
            height: "50%",
            position: "relative"
        }}/>,
        mapElement: <div className="h-100" />,
        center: {
            lat: 40.177200,
            lng: 44.503490
        },
    }),
    withStateHandlers(() => ({
        isOpen: false,
    }), {
        onToggleOpen: ({ isOpen }) => () => ({
            isOpen: !isOpen,
        })
    }),
    withScriptjs,
    withGoogleMap
)(props => (
    <GoogleMap
        defaultZoom={16}
        defaultCenter={props.defaultCenter}
        center={props.center && props.center}
        zoom={props.zoom && props.zoom}
    >
        <div className="onMapInfo">{props.info()}</div>
        {/* eslint-disable-next-line array-callback-return */}
        {props.markers && props.markers.map((item) => {
            if (item.position
                && item.position.coordinates
                && item.position.coordinates[1]
                && item.position.coordinates[0]) {
                const bikeId = item.id ? item.id : item.bike_id;
                return (
                    <MapMarker
                        key={bikeId}
                        item={item}
                        isSelected={bikeId === props.selectedBike}
                        {...props}
                    />
                );
            }
            return null;
        })}
    </GoogleMap>
));

const MapWithADirectionsRenderer = compose(
    withProps({
        googleMapURL,
        loadingElement: <Spinner />,
        containerElement: <div style={{ height: 400 }}/>,
        mapElement: <div style={{ height: "100%" }}/>,
    }),
    withScriptjs,
    withGoogleMap,
    lifecycle({
        componentDidMount() {
            // eslint-disable-next-line no-undef
            const DirectionsService = new google.maps.DirectionsService();
            DirectionsService.route({
                // eslint-disable-next-line no-undef
                origin: new google.maps.LatLng(40.191680, 44.466493),
                // eslint-disable-next-line no-undef
                destination: new google.maps.LatLng(40.201680, 44.466493),
                // eslint-disable-next-line no-undef
                travelMode: google.maps.TravelMode.WALKING,
            }, (result, status) => {
                // eslint-disable-next-line no-undef
                if (status === google.maps.DirectionsStatus.OK) {
                    this.setState({
                        directions: result,
                    });
                } else {
                    console.error(`error fetching directions ${result}`);
                }
            });
        }
    })
)(props =>
    <GoogleMap
        defaultZoom={20}
        defaultCenter={
            props.pathCoordinates
            && props.pathCoordinates[props.pathCoordinates.length - 1]
            && props.pathCoordinates[props.pathCoordinates.length - 1]
        }
    >
        {props.pathCoordinates && <Polyline
            path={props.pathCoordinates}
            options={{
                geodesic: true,
                strokeColor: "#FF2D00",
                strokeOpacity: 1.0,
                strokeWeight: 2,
                icons: [
                    {
                        icon: {
                            // eslint-disable-next-line no-undef
                            path: google.maps.SymbolPath.CIRCLE,
                            strokeOpacity: 1,
                            scale: 8,
                            strokeColor: "#00F",
                        },
                        offset: "0%"
                    },
                    {
                        icon: {
                            // eslint-disable-next-line no-undef
                            path: google.maps.SymbolPath.CIRCLE,
                            strokeOpacity: 1,
                            scale: 8,
                            strokeColor: "#E82",
                        },
                        offset: "100%"
                    },
                ],
            }}
        />}
    </GoogleMap>);

const MapUserTrip = compose(
    withProps({
        googleMapURL,
        loadingElement: <Spinner />,
        containerElement: <div style={{ height: 400 }}/>,
        mapElement: <div style={{ height: "100%" }}/>,
    }),
    withScriptjs,
    withGoogleMap,
    lifecycle({
        componentDidMount() {
            // eslint-disable-next-line no-undef
            const DirectionsService = new google.maps.DirectionsService();
            DirectionsService.route({
                // eslint-disable-next-line no-undef
                origin: new google.maps.LatLng(40.191680, 44.466493),
                // eslint-disable-next-line no-undef
                destination: new google.maps.LatLng(40.201680, 44.466493),
                // eslint-disable-next-line no-undef
                travelMode: google.maps.TravelMode.WALKING,
            }, (result, status) => {
                // eslint-disable-next-line no-undef
                if (status === google.maps.DirectionsStatus.OK) {
                    this.setState({
                        directions: result,
                    });
                } else {
                    console.error(`error fetching directions ${result}`);
                }
            });
        }
    })
)(props =>
    <GoogleMap
        defaultZoom={20}
        defaultCenter={props.pathCoordinates[0]}
    >
        {props.pathCoordinates && <Polyline
            path={props.pathCoordinates}
            options={{
                geodesic: true,
                strokeColor: "#FF2D00",
                strokeOpacity: 1.0,
                strokeWeight: 2,
                icons: [
                    {
                        icon: {
                            // eslint-disable-next-line no-undef
                            path: google.maps.SymbolPath.CIRCLE,
                            strokeOpacity: 1,
                            scale: 8,
                            strokeColor: "#00F",
                        },
                        offset: "0%"
                    },
                    {
                        icon: {
                            // eslint-disable-next-line no-undef
                            path: google.maps.SymbolPath.CIRCLE,
                            strokeOpacity: 1,
                            scale: 8,
                            strokeColor: "#E82",
                        },
                        offset: "100%"
                    },
                ],
            }}
        />}
    </GoogleMap>);

export {
    MapComponent,
    MapWithADirectionsRenderer,
    MapUserTrip
};



// WEBPACK FOOTER //
// ./src/views/pages/bikes/googleMap.js